// extracted by mini-css-extract-plugin
export var accordion = "_gl-0";
export var chevron = "_gl-3";
export var closed = "_gl-2";
export var content = "_gl-4";
export var open = "_gl-1";
export var rotate = "_gl-5";